export type ReportMentionKind = 'resource' | 'action' | 'layer';

export type ReportLayerType = 'internal' | 'external';

export type ReportMentionItem = {
  kind: ReportMentionKind;
  id: string;
  label: string;
  subtitle?: string;
  layerType?: ReportLayerType;
};

export type ReportMentionRef = {
  kind: ReportMentionKind;
  id: string;
  label: string;
  layerType?: ReportLayerType;
};

export function isReportMentionKind(
  value: string | null
): value is ReportMentionKind {
  return value === 'resource' || value === 'action' || value === 'layer';
}

export function parseMentionId(raw: string | null | undefined): {
  kind: ReportMentionKind | null;
  id: string;
  layerType?: ReportLayerType;
} {
  if (!raw) return { kind: null, id: '' };
  const parts = raw.split(':');
  const kind = parts[0];
  if (!isReportMentionKind(kind)) return { kind: null, id: raw };
  if (kind === 'layer' && (parts[1] === 'internal' || parts[1] === 'external')) {
    return { kind, id: parts.slice(2).join(':'), layerType: parts[1] };
  }
  return { kind, id: parts.slice(1).join(':') };
}

export function encodeMentionId(
  kind: ReportMentionKind,
  id: string,
  layerType?: ReportLayerType
): string {
  if (kind === 'layer' && layerType) return `layer:${layerType}:${id}`;
  return `${kind}:${id}`;
}
